// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2wgaw","noInteraction":"EventWrapper_noInteraction__3m0KP","pointerPassthrough":"EventWrapper_pointerPassthrough__mwDsN"};